import { jwtDecode } from 'jwt-decode';

export const isValidToken = (accessToken) => {
  if (!accessToken) return false;

  try {
    const decoded = jwtDecode(accessToken);

    // Just verify token is decodable and has an expiration claim
    // Don't check if it's expired - let BaseService token refresh handle that
    return Boolean(decoded?.exp);
  } catch (error) {
    return false;
  }
};

// True if the JWT decodes, has an exp claim, and exp is in the future.
// Used by useAuth to decide whether a session can be salvaged via silent
// refresh on app boot.
export const isTokenUnexpired = (token) => {
  if (!token) return false;
  try {
    const decoded = jwtDecode(token);
    if (!decoded?.exp) return false;
    return decoded.exp > Date.now() / 1000;
  } catch {
    return false;
  }
};
